import { Box, Button, Typography } from "@mui/material";
import { StyledCreateInvoiceForm } from "./CreateInvoiceForm.styled";
import { CustomerInfoCard } from "../customerInfoCard/CustomerInfoCard";
import { Project } from "../../models/Project";
import {
  InvoiceCreateDto,
  InvoiceItemDto,
} from "../../models/dto/CreateInvoiceDto";
import { CompanyInfoCard } from "../companyInfoCard/CompanyInfoCard";
import { useContext, useEffect } from "react";
import { DocumentContext } from "../../globals/LanguageContext";
import {
  formatDateToDDMMYYYY,
  formatDateToDDMMYYYYRaw,
} from "../../globals/utils";
import { PlusIcon } from "@phosphor-icons/react";
import { CreateInvoiceItemTable } from "./createInvoiceItemTable/CreateInvoiceItemTable";
import { VatTable } from "./VatTable";

type TableProps = {
  items?: InvoiceItemDto[];
};

type CreateInvoiceFormProps = {
  invoiceData: Partial<InvoiceCreateDto & { project: Project | null }>;
  onSave: (newInvoiceItem: InvoiceItemDto) => void;
  onRemove: (invoiceItem: InvoiceItemDto) => void;
  onEditItem: (id: string, value: string | number, index: number) => void;
};

export const CreateInvoiceForm = ({
  invoiceData,
  onSave,
  onRemove,
  onEditItem,
}: CreateInvoiceFormProps) => {
  const { documentDictionary } = useContext(DocumentContext);

  useEffect(
    () => console.log(invoiceData.invoiceItems),
    [invoiceData.invoiceItems],
  );

  return (
    <StyledCreateInvoiceForm>
      <Box className="invoiceWrapper">
        <Box className="invoiceHeader">
          {invoiceData.project && (
            <CustomerInfoCard customerInfo={invoiceData.project.contact} />
          )}
          <CompanyInfoCard title={documentDictionary.invoice.title} />
        </Box>
        <Box className="invoiceData">
          <Box className="head">
            <Typography variant="h4">
              {documentDictionary.invoice.documentDate}
            </Typography>
            <Typography variant="h4">
              {documentDictionary.invoice.invoiceCode}
            </Typography>
            <Typography variant="h4">
              {documentDictionary.invoice.deliveryDate}
            </Typography>
            <Typography variant="h4">
              {documentDictionary.invoice.dueDate}
            </Typography>
          </Box>
          <Box className="data">
            <Typography variant="h4">
              {formatDateToDDMMYYYY(invoiceData.invoiceDate!)}
            </Typography>
            <Typography variant="h4">{invoiceData.invoiceCode}</Typography>
            <Typography variant="h4">
              {formatDateToDDMMYYYY(invoiceData.invoiceDeliveryDate!)}
            </Typography>
            <Typography variant="h4">
              {formatDateToDDMMYYYY(invoiceData.invoiceDueDate!)}
            </Typography>
          </Box>
        </Box>
        <CreateInvoiceItemTable
          invoiceData={invoiceData}
          onSave={onSave}
          onRemove={onRemove}
          onEditItem={onEditItem}
        />
        <VatTable items={invoiceData.invoiceItems}/>
      </Box>
    </StyledCreateInvoiceForm>
  );
};
